import { render, staticRenderFns } from "./VueFuse.vue?vue&type=template&id=5a62370c&scoped=true&"
import script from "./VueFuse.vue?vue&type=script&lang=js&"
export * from "./VueFuse.vue?vue&type=script&lang=js&"
import style0 from "./VueFuse.vue?vue&type=style&index=0&id=5a62370c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a62370c",
  null
  
)

export default component.exports